import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from "reactstrap";
import { isEmpty } from "lodash";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import moment from "moment";

import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import debounce from "lodash/debounce";
import "assets/scss/table.scss";

import Breadcrumbs from "components/Common/Breadcrumb";
import { getSchemeAnalytesList } from "store/results/actions";
import { getQualitativeSummary } from "store/resultsSubmit/actions";
// import { getMicroStatisticsList } from "store/results/actions";
// import { updateRoundList } from "store/rounds/actions";
import "assets/scss/table.scss";

class SummaryResults extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      showModal: false,
      modalTitle: "",
      modalLabs: [],
      SchemeAnalytesList: [],
      buttonText: "Calculate",
      ResultSubmit: [],
      Statistics: [],
      analyte: "",
      Analyte: [],
      conditionModal: false,
      conditionModalTitle: "",
      conditionLabs: [],
      microStats: [],
      combinedData: [], // Store the combined data here
      // analyte: "",
      // rounds: [],
      isCalculated: false, // Flag to track calculation status
      successMessage: "",
      modal: false, // Modal state for visibility control
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      analyteColumns: [
        {
          text: "Analyte",
          dataField: "analyte_name",
          sort: true,
          headerStyle: { textAlign: "center" },
          align: "left",
        },
        {
          text: "Submitted Labs",
          dataField: "total_submissions",
          sort: true,
          headerStyle: { backgroundColor: "#dee9e0ff", textAlign: "center" },
          style: {
            backgroundColor: "#dee9e0ff",
            textAlign: "center",
            cursor: "pointer",
          },
          align: "center",
          formatter: (cell, row) =>
            cell === 0 ? (
              "--"
            ) : (
              <span
                onClick={() =>
                  this.handleOpenModal(
                    row.analyte_name,
                    row.analyte_id,
                    "Submitted Labs",
                    row.Submitted_labs // 👈 pass actual labs
                  )
                }
                style={{
                  color: "blue",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {cell}
              </span>
            ),
        },

        {
          text: "Positive",
          dataField: "Positive",
          sort: true,
          headerStyle: { backgroundColor: "#ace0caff", textAlign: "center" },
          style: {
            backgroundColor: "#ace0caff",
            textAlign: "center",
            cursor: "pointer",
          },
          align: "center",
          formatter: (cell, row) =>
            !cell || cell.length === 0 ? (
              "--"
            ) : (
              <span
                onClick={() =>
                  this.handleOpenModal(
                    row.analyte_name,
                    row.analyte_id,
                    "Positive"
                  )
                }
                style={{
                  color: "blue",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {cell.length} {/* ✅ show count */}
              </span>
            ),
        },
        {
          text: "Negative",
          dataField: "Negative",
          sort: true,
          headerStyle: { backgroundColor: "#f8d7da", textAlign: "center" },
          style: {
            backgroundColor: "#f8d7da",
            textAlign: "center",
            cursor: "pointer",
          },
          align: "center",
          formatter: (cell, row) =>
            !cell || cell.length === 0 ? (
              "--"
            ) : (
              <span
                onClick={() =>
                  this.handleOpenModal(
                    row.analyte_name,
                    row.analyte_id,
                    "Negative"
                  )
                }
                style={{
                  color: "blue",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {cell.length} {/* ✅ show count */}
              </span>
            ),
        },
        {
          text: "Equivocal",
          dataField: "Equivocal",
          sort: true,
          headerStyle: { backgroundColor: "#a6d4ff", textAlign: "center" },
          style: {
            backgroundColor: "#a6d4ff",
            textAlign: "center",
            cursor: "pointer",
          },
          align: "center",
          formatter: (cell, row) =>
            !cell || cell.length === 0 ? (
              "--"
            ) : (
              <span
                onClick={() =>
                  this.handleOpenModal(
                    row.analyte_name,
                    row.analyte_id,
                    "Equivocal"
                  )
                }
                style={{
                  color: "blue",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {cell.length} {/* ✅ show count */}
              </span>
            ),
        },
      ],
    };
  }
  combineData = (analytes, results) => {
    return analytes.map(analyte => {
      const resultEntry = results.find(result => result.analyte === analyte.id);
      console.log("MATCHED ENTRY FOR:", analyte.name, resultEntry); // ✅ add this
      return {
        ...analyte,
        lab_count: resultEntry?.lab_count || 0,
        correct: resultEntry?.correct || 0,
        wrong: resultEntry?.wrong || 0,
        not_submitted: resultEntry?.not_submitted || 0,
      };
    });
  };

  isAllFieldsZero = data => {
    // Check if all the relevant fields in the data are equal to 0
    return data.every(
      item =>
        item.lab_count === 0 &&
        item.correct === 0 &&
        item.wrong === 0 &&
        item.not_submitted === 0
    );
  };

  componentDidMount() {
    const { onGetSchemeAnalyte, onGetQualitativeSummary } = this.props;
    const id = this.props.match.params.id;

    console.log("🔵 componentDidMount -> Round ID:", id);

    // ✅ Fetch scheme analytes
    onGetSchemeAnalyte(id);

    // ✅ Fetch qualitative summary too
    onGetQualitativeSummary(id);
  }
  componentDidUpdate(prevProps) {
    const { AnalyteStatistics, qualitativeSummary } = this.props;

    if (this.props.qualitativeSummary !== prevProps.qualitativeSummary) {
      console.log(
        "🟢 Page received Qualitative Summary:",
        this.props.qualitativeSummary
      );
    }

    if (
      AnalyteStatistics !== prevProps.AnalyteStatistics &&
      !isEmpty(AnalyteStatistics)
    ) {
      console.log("🔬 analyte Stats Payload:", AnalyteStatistics);

      const analyteRows =
        qualitativeSummary?.analytes
          ?.sort((a, b) => a.analyte_name.localeCompare(b.analyte_name))
          ?.map((row, idx) => ({
            id: idx + 1,
            analyte_id: row.analyte_id,
            analyte_name: row.analyte_name || `Analyte ${idx + 1}`,
            total_submissions: row.total_submissions || 0,
            Positive: row.Positive || [], // ✅ keep full array
            Negative: row.Negative || [],
            Equivocal: row.Equivocal || [],
            Submitted_labs: row.Submitted_labs || [],
          })) || [];

      this.setState({ analyteStats: analyteRows });
    }

    if (
      qualitativeSummary !== prevProps.qualitativeSummary &&
      !isEmpty(qualitativeSummary)
    ) {
      console.log("🟢 Qualitative Summary Payload:", qualitativeSummary);

      if (
        qualitativeSummary !== prevProps.qualitativeSummary &&
        !isEmpty(qualitativeSummary)
      ) {
        console.log("🟢 Qualitative Summary Payload:", qualitativeSummary);

        const analyteRows =
          qualitativeSummary?.analytes
            ?.slice()
            .sort((a, b) => a.analyte_name.localeCompare(b.analyte_name))
            .map((row, idx) => ({
              id: idx + 1,
              analyte_id: row.analyte_id,
              analyte_name: row.analyte_name || `Analyte ${idx + 1}`,
              total_submissions: row.total_submissions || 0,
              Positive: row.Positive || [], // ✅ keep array
              Negative: row.Negative || [],
              Equivocal: row.Equivocal || [],
              Submitted_labs: row.Submitted_labs || [],
            })) || [];

        this.setState({
          analyteStats: analyteRows,
          qualitativeSummary: qualitativeSummary,
        });
      }
    }
  }

  handleOpenModal = (title, analyteId, resultType, labsOverride = null) => {
    let labs = labsOverride;

    if (!labs) {
      const analyte = this.props.qualitativeSummary?.analytes.find(
        a => a.analyte_id === analyteId
      );
      labs = analyte ? analyte[resultType] || [] : [];
    }

    this.setState({
      showModal: true,
      modalTitle: `${title} - ${resultType}`,
      modalLabs: labs,
    });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, modalTitle: "", modalLabs: [] });
  };

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };
  handleConditionClick = condition => {
    const labs = this.props.sample_condition_labs?.[condition] || [];
    this.setState({
      conditionModal: true,
      conditionModalTitle: condition,
      conditionLabs: labs,
    });
  };
  render() {
    // };
    const {
      closing_date,
      rounds,
      scheme_name,
      scheme_type,
      cycle_no,
      round_issuedate,
      round_status,
    } = this.props;

    const { combinedData } = this.state; // Use the combined data
    const pageOptions = {
      sizePerPage: 10,
      totalSize: combinedData.length, // Adjust totalSize for combined data
      custom: true,
    };
    const { sample_condition_counts } = this.props;
    const defaultSorted = [
      {
        dataField: "analyte_name",
        order: "desc",
      },
    ];
    // const microStats = this.props.Statistics?.statistics || [];
    const microStats = this.state.microStats || [];
    const { qualitativeSummary } = this.props;

    const { issue_date } = this.props;
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Statistics | NEQAS</title>
          </MetaTags>
          <Container fluid>
            <Row className="mb-3">
              <Col className="text-start">
                <Button
                  color="primary"
                  onClick={() => this.props.history.goBack()}
                >
                  ← Back
                </Button>
              </Col>
            </Row>

            {/* Modal for displaying success message */}
            <Modal isOpen={this.state.showModal} toggle={this.handleCloseModal}>
              <ModalHeader toggle={this.handleCloseModal}>
                {this.state.modalTitle}
              </ModalHeader>
              <ModalBody>
                {this.state.modalLabs.length > 0 ? (
                  <ul>
                    {this.state.modalLabs.map((lab, i) => (
                      <li key={i}>
                        {lab.name} ({lab.result_type})
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No labs found.</p>
                )}
              </ModalBody>
            </Modal>

            <div className="container">
              <Row className="mb-4">
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Round:</span>
                    <span>
                      <strong>{rounds ? rounds : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Scheme Name:</span>
                    <span>
                      <strong>{scheme_name ? scheme_name : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Scheme Type:</span>
                    <span>
                      <strong>{scheme_type ? scheme_type : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Cycle No:</span>
                    <span>
                      <strong>{cycle_no ? cycle_no : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Closing Date:</span>
                    <span>
                      <strong>
                        {closing_date
                          ? moment(closing_date).format("DD-MMM-YY, h:mm A")
                          : "N/A"}
                      </strong>
                    </span>
                  </div>
                </Col>

                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Issued Date:</span>
                    <span>
                      <strong>
                        {round_issuedate
                          ? moment(round_issuedate).format(
                              "DD-MMM-YY, h:mm A"
                            )
                          : "N/A"}
                      </strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Status:</span>
                    <span>
                      <strong>{round_status ? round_status : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
            {sample_condition_counts &&
              Object.keys(sample_condition_counts).length > 0 &&
              (() => {
                const validConditions = Object.entries(
                  sample_condition_counts
                ).filter(
                  ([condition, count]) =>
                    condition &&
                    condition !== "Not Selected" &&
                    condition !== "null" &&
                    condition !== "undefined" &&
                    condition.trim() !== "" &&
                    count > 0
                );

                return (
                  validConditions.length > 0 && (
                    <Row className="mb-3" style={{ marginLeft: "170px" }}>
                      <Col md={12}>
                        <div className="d-flex flex-wrap align-items-center gap-3">
                          <span
                            className="text-muted fw-semibold"
                            style={{ fontSize: "13px", whiteSpace: "nowrap" }}
                          >
                            Sample Condition:
                          </span>

                          {validConditions.map(([condition, count]) => (
                            <div
                              key={condition}
                              className="border rounded px-3 py-1 d-flex align-items-center gap-2"
                            >
                              <span
                                className="text-muted"
                                style={{ fontSize: "12px" }}
                              >
                                {condition}
                              </span>

                              <strong
                                style={{
                                  fontSize: "15px",
                                  color: "#0d6efd",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  const labs =
                                    this.props.sample_condition_labs?.[
                                      condition
                                    ] || [];

                                  this.setState({
                                    conditionModal: true, // ✅ open the correct modal
                                    conditionModalTitle: condition,
                                    conditionLabs: labs,
                                  });
                                }}
                              >
                                {count}
                              </strong>
                            </div>
                          ))}
                        </div>
                      </Col>
                    </Row>
                  )
                );
              })()}
            <Modal
              isOpen={this.state.conditionModal}
              toggle={() => this.setState({ conditionModal: false })}
            >
              <ModalHeader
                toggle={() => this.setState({ conditionModal: false })}
              >
                {this.state.conditionModalTitle}
              </ModalHeader>
              <ModalBody>
                {this.state.conditionLabs.length > 0 ? (
                  <ul className="list-group list-group-flush">
                    {this.state.conditionLabs.map((lab, i) => (
                      <li
                        key={i}
                        className="list-group-item py-2"
                        style={{ border: "none" }}
                      >
                        {lab}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="text-muted text-center py-3">
                    No labs found.
                  </div>
                )}
              </ModalBody>
            </Modal>
            <Row className="justify-content-center">
              {/* Analyte Table */}
              <Col xs="12" sm="12" md="12" lg="9">
                <Card>
                  <CardBody>
                    <h5>
                      <strong>Qualitative Summary</strong>
                    </h5>
                    <ToolkitProvider
                      keyField="id"
                      columns={this.state.analyteColumns}
                      data={this.state.analyteStats || []}
                      search
                    >
                      {toolkitProps => (
                        <BootstrapTable {...toolkitProps.baseProps} />
                      )}
                    </ToolkitProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

SummaryResults.propTypes = {
  match: PropTypes.object,
  className: PropTypes.any,
  SchemeAnalytesList: PropTypes.array,
  ResultSubmit: PropTypes.array,
  Statistics: PropTypes.array,
  AnalyteStatistics: PropTypes.array,
  rounds: PropTypes.string,
  issue_date: PropTypes.object,
  scheme_name: PropTypes.string,
  scheme_type: PropTypes.string,
  rounds: PropTypes.string,
  closing_date: PropTypes.string,
  round_issuedate: PropTypes.string,
  round_status: PropTypes.string,
  cycle_no: PropTypes.string,
  ListAnalyte: PropTypes.array,
  // closing_date: PropTypes.string,
  onGetSchemeAnalyte: PropTypes.func,
  onGetQualitativeSummary: PropTypes.func,
  qualitativeSummary: PropTypes.object,
  history: PropTypes.object.isRequired,
  sample_condition_counts: PropTypes.object,
  sample_condition_labs: PropTypes.object,
};
const mapStateToProps = ({ SchemeAnalytesList, ResultSubmit }) => ({
  SchemeAnalytesList: SchemeAnalytesList.SchemeAnalytesList,
  ResultSubmit: ResultSubmit.ResultSubmit,
  AnalyteStatistics: SchemeAnalytesList.AnalyteStatistics,
  qualitativeSummary: ResultSubmit.qualitativeSummary, // ✅ correct

  rounds: SchemeAnalytesList.rounds,
  rounds_instance: SchemeAnalytesList.rounds_instance,
  closing_date: SchemeAnalytesList.closing_date,

  scheme_name: SchemeAnalytesList.schemeName,
  scheme_type: SchemeAnalytesList.schemeType,
  round_issuedate: SchemeAnalytesList.issue_date,
  round_status: SchemeAnalytesList.round_status,
  cycle_no: SchemeAnalytesList.cycle_no,
  sample_condition_counts: SchemeAnalytesList.sampleConditionCounts,
  sample_condition_labs: SchemeAnalytesList.sampleConditionLabs,
});

const mapDispatchToProps = dispatch => ({
  onGetSchemeAnalyte: id => dispatch(getSchemeAnalytesList(id)),
  onGetQualitativeSummary: id => dispatch(getQualitativeSummary(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SummaryResults));
